var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { getPath, getFullPath, getPreviousFullPath, getMatchRoute, } from "./common";
var defaultOptions = {
    host: "https://dev-tracking.teko.vn",
    urlServeJsFile: "https://dev-tracking.teko.vn/track/libs/tracker.full.min.js",
};
var init = function (f, b, e, v, i, r, t, s) {
    // Stop if tracker already exists
    if (f[i])
        return;
    // Initialise the 'GlobalTrackerNamespace' array
    f["GlobalTrackerNamespace"] = f["GlobalTrackerNamespace"] || [];
    // Add the new Tracker namespace to the global array so tracker.js can find it
    f["GlobalTrackerNamespace"].push(i);
    // Add endpoint
    f["GlobalTrackerNamespace"].push(r);
    // Create the Snowplow function
    f[i] = function () {
        (f[i].q = f[i].q || []).push(arguments);
    };
    // Initialise the asynchronous queue
    f[i].q = f[i].q || [];
    // Create a new script element
    t = b.createElement(e);
    // The new script should load asynchronously
    t.async = !0;
    // Load Tracker-js
    t.src = v;
    // Get the first script on the page
    s = b.getElementsByTagName(e)[0];
    // Insert the Snowplow script before every other script so it executes as soon as possible
    s.parentNode.insertBefore(t, s);
    // add listener error
    // @ts-ignore
    window.onerror = function (msg, url, lineNo, columnNo, error) {
        f[i]("exception", { msg: msg, error: error });
        return false;
    };
    // add listener onunhandledrejection
    window.onunhandledrejection = function (event) {
        f[i]("exception", {
            msg: event.reason ? event.reason.message : "unknown",
            error: "unhandledrejection",
        });
        return false;
    };
};
var ReactTracker = /** @class */ (function () {
    function ReactTracker(setupOptions) {
        var _this = this;
        this.routes = [];
        this.registerListener = function (history) {
            var prevLoc = typeof history.getCurrentLocation === "undefined"
                ? history.location
                : history.getCurrentLocation();
            _this.previousPath = getPath(prevLoc);
            _this.previousFullPath = getPreviousFullPath(null, prevLoc);
            window.track("setReferrerUrl", _this.previousFullPath);
            var currentFullPath = document.location.href;
            window.track("trackLoadPageView", __assign({}, _this.getExtraAttr(currentFullPath)));
            _this.unlistenFromHistory = history.listen(function (action) {
                // if users use history v5, Location object will be in action.location,
                // else if users use history v4, action will be a Location object.
                // read more at https://gist.github.com/StringEpsilon/47820cc961c8d82f3b71dc856b5cc616#historylisten
                if (action.location) {
                    _this.track(action.location);
                }
                else {
                    _this.track(action);
                }
            });
        };
        var options = __assign(__assign({}, defaultOptions), setupOptions);
        var host = options.host, urlServeJsFile = options.urlServeJsFile;
        init(window, document, "script", urlServeJsFile, "track", host);
        if (options.appId) {
            window.track("init", options.appId);
        }
    }
    ReactTracker.prototype.connectToHistory = function (history, routes) {
        if (routes === void 0) { routes = []; }
        this.routes = routes;
        if (this.history) {
            return history;
        }
        this.history = history;
        this.registerListener(history);
        return history;
    };
    ReactTracker.prototype.disconnectFromHistory = function () {
        if (this.unlistenFromHistory) {
            this.unlistenFromHistory();
            return true;
        }
        return false;
    };
    ReactTracker.prototype.getExtraAttr = function (currentPath) {
        if (!this.routes || this.routes.length === 0)
            return {};
        var _a = getMatchRoute(currentPath, this.routes) || {}, contentType = _a.contentType, screenName = _a.screenName, skuId = _a.skuId, skuName = _a.skuName;
        return JSON.parse(JSON.stringify({ contentType: contentType, screenName: screenName, skuId: skuId, skuName: skuName }));
    };
    ReactTracker.prototype.track = function (loc) {
        if (typeof window === "undefined") {
            return;
        }
        var currentPath = getPath(loc);
        var currentFullPath = getFullPath(loc);
        if (this.previousPath === currentPath) {
            return;
        }
        window.track("setCurrentUrl", this.previousFullPath);
        window.track("trackUnLoadPageView", __assign({}, this.getExtraAttr(this.previousFullPath)));
        window.track("setReferrerUrl", this.previousFullPath);
        window.track("setCurrentUrl", currentFullPath);
        window.track("trackLoadPageView", __assign({}, this.getExtraAttr(currentFullPath)));
        this.previousPath = currentPath;
        this.previousFullPath = currentFullPath;
    };
    return ReactTracker;
}());
export * from "./hooks";
export default ReactTracker;
//# sourceMappingURL=index.js.map